/* eslint react/prop-types: 0 */
import React from "react";
import { navigate } from "gatsby";

import { translateStatic } from "../helpers/translationHelper";

class Properties extends React.Component {
  constructor(props) {
    super(props);

    const {
      allProperties,
      propertyObj,
      locale,
      prefix
    } = props.pageContext;

    this.state = {
      searchedProperties: allProperties,
      properties: propertyObj.data,
      paginatorInfo: propertyObj.paginatorInfo,
      navigationPrefix: `${locale}/${prefix}`,
      sortOptions: {},
      sort: "",
      latitude: null,
      longitude: null,
      zoom: 12
    };
  }

  componentDidMount() {
    let { search } = this.props.location;
    let params = new URLSearchParams(search);

    const sortColumn = params.get("sort_column");
    const sortOrder = params.get("sort_order");
    if (sortColumn && sortOrder) {
      this.setState({ sort: `${sortColumn}-${sortOrder}` });
    }
    this.initializeSortOptions();
  }

  initializeSortOptions() {
    let {
      currentLocaleKey: locale,
      defaultLocaleKey: defaultLocale,
    } = this.props.result;
    let asc = translateStatic("asc", locale, defaultLocale);
    let desc = translateStatic("desc", locale, defaultLocale);
    let columns = [
      "created_at",
      "updated_at",
      "selling_price",
      "rental_price",
      "bedrooms",
      "bathrooms",
    ];
    let sortOptions = {};
    for (let column of columns) {
      let columnName = translateStatic(column, locale, defaultLocale);
      sortOptions[column + "-asc"] = `${columnName} (${asc})`;
      sortOptions[column + "-desc"] = `${columnName} (${desc})`;
    }
    this.setState({ sortOptions });
  }

  handleSortChange = (event) => {
    const { value } = event.target;
    const { search } = this.props.location;
    let params = new URLSearchParams(search);
    if (value) {
      const [column, order] = value.split("-");
      params.set("sort_column", column);
      params.set("sort_order", order);
      navigate(`/${this.state.navigationPrefix}?${params.toString()}`);
    } else {
      params.delete("sort_column");
      params.delete("sort_order");
      navigate(`/${this.state.navigationPrefix}?${params.toString()}`);
    }
  };

  setProperties = (searchedProperties, paginatedData) => {
    this.setState((state) => ({
      searchedProperties: searchedProperties,
      properties: paginatedData.data,
      paginatorInfo: paginatedData.paginatorInfo,
    }));
  };

  setMapOptions = (latitude, longitude, zoom) => {
    if (zoom) {
      if (!isNaN(zoom)) this.setState({ zoom: parseInt(zoom) });
    }
    this.setState({ latitude, longitude });
  }
}

export default Properties;
